export const regions = [
  { label: "Domestic", value: "Domestic" },
  { label: "Regional", value: "Regional" },
];

export const organizations = [
  { label: "Subsidiary", value: "Subsidiary" },
  { label: "Joint Venture", value: "Joint Venture" },
];

export interface LabelValueType {
  label: string;
  value: string;
}

export enum EnumFilterMapCompany {
  REGION = "regions",
  ORGANIZATION = "organizations",
  COMPANY_GROUP = "companyGroupId",
  COMPANY = "company",
  TEXT_SEARCH = "textSearch",
}
